import { Box } from "@mui/material";
import React from "react";
import { InputDate } from "../../controls";
import dayjs from "dayjs";

const DateRange = ({ sortDate, setSortDate }) => {
  const handleDate = (name, newVal) => {
    setSortDate((x) => ({ ...x, [name]: newVal }));
  };

  return (
    <Box
      sx={{
        width: { xs: "100%" },
        maxWidth: { md: "380px" },
      }}
      className="d-flex a-center j-center g-5 w-full md:max-w-[380px]"
    >
      <InputDate
        size="small"
        variant="outlined"
        name="fromDate"
        value={sortDate.fromDate}
        views={["day", "month", "year"]}
        openTo="day"
        minDate={dayjs("01/01/2000")}
        maxDate={sortDate.toDate ? sortDate.toDate.subtract(1, "day") : null}
        onChange={(date) => handleDate("fromDate", date)}
      />
      <span className="text-[16px] text-gray-500">TO</span>
      <InputDate
        size="small"
        variant="outlined"
        name="toDate"
        value={sortDate.toDate}
        minDate={sortDate.fromDate ? sortDate.fromDate.add(1, "day") : null}
        views={["day", "month", "year"]}
        openTo="day"
        onChange={(date) => handleDate("toDate", date)}
      />
    </Box>
  );
};

export default DateRange;
